import * as Actions from '../actions'

Actions.withOperationName(Actions)

export default [
  Actions.setSyncMark,
  Actions.updateProgress('sending'),
  Actions.safeSetMessageIds,
  Actions.ensureSyncIdSaved,
  Actions.melodyLoftAzure,
  Actions.stopProgress,
  Actions.loftSuccess,
  Actions.itemClose,
]
